import moment from 'moment';

import { NewsPost } from './types';
import React from 'react';

export const NewsCard = ({
  post: { createdAt, excerpt, image, permalink, title, thumbnail },
}: {
  post: NewsPost;
}) => {
  return (
    <div
      className={`
        flex
        shadow-md
        border-1
        rounded-lg
        p-4
        ${permalink ? 'cursor-pointer' : 'pointer-events-none'}
        border-grey-10
        dark:border-grey-80
        hover:border-grey-50
      `}
      onClick={() => permalink && window.open(permalink)}
    >
      <div className={'block'}>
        <div className={'flex flex-col w-full'}>
          <div className={'text-xs text-grey-50 mb-2'}>
            {moment(createdAt).format('h:mm A - MMM DD YYYY')}
          </div>
          {(image || thumbnail) && (
            <div className="bg-grey-10 overflow-hidden w-full h-32 rounded-lg">
              <img src={image ?? thumbnail} className={'w-full'} alt={''} />
            </div>
          )}
        </div>
        <div className={'my-2 font-semibold'}>
          <span className={'text-container'}>{title}</span>
        </div>
        <div className={'my-2 text-sm'}>{excerpt}</div>
      </div>
    </div>
  );
};
